import { render, staticRenderFns } from "./serviceImplManage.vue?vue&type=template&id=b6f320c0&scoped=true"
import script from "./serviceImplManage.vue?vue&type=script&lang=js"
export * from "./serviceImplManage.vue?vue&type=script&lang=js"
import style0 from "./serviceImplManage.vue?vue&type=style&index=0&id=b6f320c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f320c0",
  null
  
)

export default component.exports